import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e829c49a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { getEntityTranslation } from "@/helpers";
import { Field } from "@/types/interfaces/field";
import { SoMeDto } from "@api/so-me-dto";
import { DraftCompanySoMeDto } from "@api/draft-company-so-me-dto";
import { computed, inject, PropType, ref, watch } from "vue";
import _ from "lodash";
import publicFormApi from "@/publicFormApi";
import { CompanySoMeDto } from "@api/company-so-me-dto";
import { CompanyFieldDto } from "@api/company-field-dto";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanySoMesField',
  props: {
	modelValue: {
		type: Array as PropType<DraftCompanySoMeDto[] | CompanySoMeDto[] | null>,
		required: true,
	},
	field: {
		type: Object as PropType<Field>,
		required: false,
	},
	isUpdateForm: {
		type: Boolean as PropType<boolean>,
		default: false,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const somes = ref([] as SoMeDto[]);
const orgUsingPublicDirectory = inject("orgUsingPublicDirectory", false);

const selectedSomeIds = ref([] as number[]);
if (props.modelValue) {
	selectedSomeIds.value = props.modelValue.map((r) => r.soMeId);
}

const getSomes = async () => {
	const resp = await publicFormApi.call.companyForm.get.somes();
	if (resp.isSuccessful && resp.data) {
		somes.value = _.cloneDeep(resp.data);
	}
};
getSomes();

watch(
	selectedSomeIds,
	(newVal) => {
		if (!Array.isArray(newVal)) return;

		newVal.forEach((someId) => {
			if (cModelValue.value.findIndex((x) => x.soMeId == someId) == -1) {
				const some: SoMeDto | undefined = somes.value.filter((r) => r.id == someId).pop();
				if (some) {
					let newCompanySome;
					if (props.isUpdateForm) {
						newCompanySome = {
							soMe: some,
							soMeId: some.id,
							url: "",
							companyId: 0,
						} as unknown as CompanySoMeDto;
					} else {
						newCompanySome = {
							soMe: some,
							soMeId: some.id,
							url: "",
							draftCompanyId: 0,
						} as unknown as DraftCompanySoMeDto;
					}

					cModelValue.value.push(newCompanySome);
				}
			}
		});

		if (newVal.length == 0) {
			cModelValue.value = [] as DraftCompanySoMeDto[];
		} else {
			cModelValue.value = cModelValue.value.filter((x) => newVal.includes(x.soMeId));
		}
	},
	{ deep: true }
);

const cModelValue = computed<DraftCompanySoMeDto[] | CompanySoMeDto[]>({
	get() {
		if (props.isUpdateForm) return props.modelValue as CompanySoMeDto[];
		else return props.modelValue as DraftCompanySoMeDto[];
	},
	set(newVal: DraftCompanySoMeDto[] | CompanySoMeDto[]) {
		emit("update:modelValue", newVal);
	},
});

return (_ctx: any,_cache: any) => {
  const _component_HakoCheckbox = _resolveComponent("HakoCheckbox")!
  const _component_HakoLabelControl = _resolveComponent("HakoLabelControl")!
  const _component_HakoInput = _resolveComponent("HakoInput")!

  return (_openBlock(), _createElementBlock("div", null, [
    (somes.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_HakoLabelControl, {
            block: true,
            "col-size": 2,
            required: 
					(__props.isUpdateForm
						? (__props.field as CompanyFieldDto)?.isRequiredOnCompanyUpdateForm
						: __props.field?.isRequiredOnPublicForm) ?? false
				,
            for: "soMeCheckboxes"
          }, {
            label: _withCtx(() => [
              _renderSlot(_ctx.$slots, "label"),
              (!_ctx.$slots.label)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(getEntityTranslation)(__props.field?.translations, "name")) + " ", 1),
                    (__props.isUpdateForm && _unref(orgUsingPublicDirectory))
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: "show-public-icon",
                          style: _normalizeStyle(
								__props.field?.isDisplayedInPublicDirectory
									? 'background-color: #32b769'
									: 'background-color: gray'
							)
                        }, null, 4))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(somes.value, (s) => {
                return (_openBlock(), _createBlock(_component_HakoCheckbox, {
                  key: `somekey_${s.id}`,
                  for: `someid_${s.id}`,
                  id: `someid_${s.id}`,
                  inline: "",
                  value: s.id,
                  modelValue: selectedSomeIds.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedSomeIds).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(s.name) + " ", 1),
                    _createElementVNode("img", {
                      src: s.iconUrl,
                      class: "some-icon"
                    }, null, 8, _hoisted_1)
                  ]),
                  _: 2
                }, 1032, ["for", "id", "value", "modelValue"]))
              }), 128))
            ]),
            _: 3
          }, 8, ["required"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.modelValue, (x) => {
            return (_openBlock(), _createBlock(_component_HakoLabelControl, {
              key: `someurlfield_${x.someId}`,
              "col-size": 2,
              block: true,
              label: x.soMe.name,
              for: `someurl_${x.soMeId}`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_HakoInput, {
                  id: `someurl_${x.soMeId}`,
                  type: "text",
                  modelValue: x.url,
                  "onUpdate:modelValue": ($event: any) => ((x.url) = $event),
                  style: {"max-width":"500px"}
                }, null, 8, ["id", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["label", "for"]))
          }), 128))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})